$(document).on("ready turbo:load", function () {
  // moment.locale('de')

  $(function () {
    var startDateElem = $("#booking_room_form_start_date");
    var endDateElem = $("#booking_room_form_end_date");
    startDateElem.datepicker({
      defaultDate: new Date(),
      dateFormat: "dd.mm.yy",
      minDate: new Date(),
      numberOfMonths: 1,
      onClose: function (selectedDate) {
        d = moment(selectedDate, "DD.MM.YYYY")
          .add(1, "days")
          .format("DD.MM.YYYY");
        endDateElem.datepicker("option", "minDate", d);
      },
    });
    endDateElem.datepicker({
      defaultDate: "+1d",
      dateFormat: "dd.mm.yy",
      minDate: +1,
      numberOfMonths: 1,
      onClose: function (selectedDate) {
        if ($.isEmptyObject(selectedDate)) {
          d = selectedDate;
        } else {
          d = moment(selectedDate, "DD.MM.YYYY")
            .subtract(1, "days")
            .format("DD.MM.YYYY");
        }
        startDateElem.datepicker("option", "maxDate", d);
      },
    });
  });
});
